import { useEffect, useState } from "react";

export default function PageScrollProgress() {
  const [scrollPercent, setScrollPercent] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const docHeight =
        document.documentElement.scrollHeight - window.innerHeight;
      const scrolled = (scrollTop / docHeight) * 100;
      setScrollPercent(scrolled);
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // initial call on mount

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className=" left-0 w-full h-1 bg-gray-300 z-50">
      <div
        className="h-full bg-orange-600 transition-all duration-150 ease-out"
        style={{ width: `${scrollPercent}%` }}
      />
    </div>
  );
}
